import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CookieProperty } from ".";
import { applyDynamicsToHtml } from "@devowl-wp/headless-content-unblocker";
import { useBannerOrBlocker, useDurationText } from "../../../hooks";
const CookiePropertyTechnicalDefinitionsTable = (param)=>{
    let { definitions: definitions, codeDynamics } = param;
    const { i18n } = useBannerOrBlocker();
    const generateDurationText = useDurationText();
    const types = getCookieTypeLocalizationMap();
    return definitions == null ? void 0 : definitions.map((param)=>{
        let { children, type, name, host, duration, durationUnit, isSessionDuration, purpose } = param;
        var _types_type;
        return /*#__PURE__*/ _jsxs(CookieProperty, {
            label: i18n.technicalCookieName,
            monospace: true,
            value: applyDynamicsToHtml(name, codeDynamics),
            children: [
                /*#__PURE__*/ _jsx(CookieProperty, {
                    label: i18n.type,
                    value: ((_types_type = types[type]) == null ? void 0 : _types_type.name) || type
                }),
                !!host && /*#__PURE__*/ _jsx(CookieProperty, {
                    label: i18n.host,
                    value: host,
                    monospace: true
                }),
                /*#__PURE__*/ _jsx(CookieProperty, {
                    label: i18n.duration,
                    value: [
                        "local",
                        "indexedDb"
                    ].indexOf(type) > -1 ? i18n.noExpiration : isSessionDuration || type === "session" ? "Session" : generateDurationText(duration, durationUnit)
                }),
                children,
                /*#__PURE__*/ _jsx(CookieProperty, {
                    label: i18n.purpose,
                    value: purpose
                })
            ]
        }, `${type}-${name}-${host}`);
    });
};
function getCookieTypeLocalizationMap() {
    return {
        http: {
            name: "HTTP Cookie",
            abbr: "HTTP",
            backgroundColor: "black"
        },
        local: {
            name: "Local Storage",
            abbr: "Local",
            backgroundColor: "#b3983c"
        },
        session: {
            name: "Session Storage",
            abbr: "Session",
            backgroundColor: "#3c99b3"
        },
        indexedDb: {
            name: "IndexedDB",
            abbr: "I-DB",
            backgroundColor: "#4ab33c"
        }
    };
}
export { CookiePropertyTechnicalDefinitionsTable, getCookieTypeLocalizationMap };
